<template>
  <VanPopup
    v-model:show="visible"
    :position="platform === 'pc' ? 'center' : 'bottom'"
    round
    :style="platform === 'pc' ? undefined : { maxHeight: '85vh' }"
    :class="['kilimall-choice-popup', { 'kilimall-choice-popup--pc': platform === 'pc' }]"
  >
    <div class="popup-container">
      <div class="popup-header">
        <p class="popup-title">What is Kilimall Choice?</p>
        <img
          class="popup-header-img"
          :src="$cvWebpFn(CHOICE_ICONS.thumb, { w: 240 })"
          alt=""
        />
        <button type="button" class="popup-close" aria-label="Close" @click="visible = false">
          <img
            class="popup-close-icon"
            :src="$cvWebpFn(CHOICE_ICONS.close, { w: 48 })"
            alt=""
          />
        </button>
      </div>
      <div class="popup-bj" />
      <div class="popup-body">
        <div class="popup-body-container">
          <p class="popup-intro">
            Product with this badge means It's a top pick based on real customer reviews, fast delivery, and reliable service. You can shop with confidence!
          </p>
          <div class="feature-list">
            <div v-for="item in featureList" :key="item.title" class="feature-item">
              <img class="feature-icon" :src="$cvWebpFn(item.icon, { w: 144 })" :alt="item.title" />
              <p class="feature-title">{{ item.title }}</p>
              <p class="feature-desc">{{ item.desc }}</p>
            </div>
          </div>
        </div>
        <button type="button" class="continue-btn" @click="visible = false">Continue Shopping</button>

        <p class="popup-note">
          Note: This badge guarantees quality for this product only. Other products in the same store might have different ratings.
        </p>
      </div>
    </div>
  </VanPopup>
</template>

<script setup lang="ts">
withDefaults(defineProps<{
  platform?: 'wap' | 'pc'
}>(), {
  platform: 'wap'
})

const CHOICE_ICONS = {
  thumb: 'https://image.kilimall.com/c/h5/thumb.png',
  close: 'https://image.kilimall.com/c/h5/ic_back_normal.png',
  highlyRated: 'https://image.kilimall.com/c/h5/ic_highly_rated.png',
  safeToBuy: 'https://image.kilimall.com/c/h5/ic_safe_to_buy.png',
  fastShipping: 'https://image.kilimall.com/c/h5/ic_fast_shipping.png'
}

const visible = defineModel<boolean>('visible', { default: false })

const featureList = [
  {
    title: 'Highly Rated',
    desc: 'Loved by many shoppers.',
    icon: CHOICE_ICONS.highlyRated
  },
  {
    title: 'Safe to Buy',
    desc: 'Passed quality checks & warranty support.',
    icon: CHOICE_ICONS.safeToBuy
  },
  {
    title: 'Fast Shipping',
    desc: 'Stock secured & lower cancellation.',
    icon: CHOICE_ICONS.fastShipping
  }
]
</script>

<style lang="scss" scoped>
.popup-container {
  background: #F5F5F5;
}
.popup-header {
  position: relative;
  min-height: 120px;
  padding: 40px 20px;
  background: #FFE5C7;
  border-radius: 24px 24px 0 0;
}
.popup-bj {
  width: 100%;
  height: 129px;
  background: linear-gradient(180deg, #FFE5C7 0%, #F5F5F5 50.31%);
}
.popup-title {
  margin: 0;
  color: #5c2f1a;
  font-family: Georgia, 'Times New Roman', serif;
  font-size: 34px;
  font-weight: 700;
  line-height: 42px;
}

.popup-header-img {
  position: absolute;
  top: 5px;
  right: 90px;
  width: 123px;
  height: 110px;
}

.popup-close {
  position: absolute;
  top: 40px;
  right: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px;
  padding: 0;
  box-sizing: border-box;
  border-radius: 50%;
  border: 0;
  background: #FFE5C7;
  cursor: pointer;
}

.popup-close-icon {
  display: block;
  width: 42px;
  height: 42px;
}

.popup-body {
  margin: 20px 20px 30px 20px;
  margin-top: -129px;
}
.popup-body-container {
  background: #fff;
  border-radius: 20px;
  padding: 30px 20px 20px 20px;
}
.popup-intro {
  margin: 0 0 20px;
  color: #333;
  font-size: 28px;
  line-height: 38px;
}

.feature-list {
  display: flex;
  gap: 12px;
}

.feature-item {
  flex: 1;
  min-width: 0;
  text-align: center;
  width: 206px;
  height: 247px;
  border-radius: 8px;
  background: #fff4e8b3;
}

.feature-icon {
  display: block;
  width: 60px;
  height: 60px;
  margin: 32px auto 12px;
}

.feature-title {
  margin-top: 28px;
  color: #222;
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
}

.feature-desc {
  margin: 8px 0 0;
  color: #666;
  font-size: 20px;
  line-height: 26px;
}

.continue-btn {
  display: block;
  width: 100%;
  height: 80px;
  padding: 18px 24px;
  border: none;
  border-radius: 60px;
  background: #E14646;
  color: #fff;
  font-size: 34px;
  font-weight: 700;
  line-height: 36px;
  margin-top: 30px;
  cursor: pointer;
}

.popup-note {
  margin: 30px 0 10px 0;
  color: #999;
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  text-align: left;
}

.kilimall-choice-popup--pc {
  .popup-container {
    width: 720px;
    max-height: 85vh;
    overflow-y: auto;
    border-radius: 24px;
    @include pc__scrollbar('', 8px);
  }
}
</style>
